import { Paragraph, Table } from '@zillow/constellation-10';
import React from 'react';
import { NOT_PROVIDED } from '../TableContent';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '@zg-rentals/satellite-components';

type Props = {
  email?: string;
  phone?: string;
};

export default function ContactInfoTableCell({ email, phone }: Props): JSX.Element {
  const hasEmailOrPhone = email || phone;

  return (
    <Table.Cell css={{ verticalAlign: 'middle' }}>
      {hasEmailOrPhone ? (
        <>
          {phone && (
            <Paragraph className={FULLSTORY_EXCLUDE_CLASS_NAME} textStyle="body-sm">
              {phone}
            </Paragraph>
          )}
          {email && (
            <Paragraph className={FULLSTORY_EXCLUDE_CLASS_NAME} textStyle="body-sm">
              {email}
            </Paragraph>
          )}
        </>
      ) : (
        <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
          {NOT_PROVIDED}
        </Paragraph>
      )}
    </Table.Cell>
  );
}
